import { Component, OnInit } from '@angular/core';
import * as _ from 'underscore';
import { PATHS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';

@Component({
	selector: 'app-printable-nav',
	templateUrl: './printable-nav.component.html',
	styleUrls: ['./printable-nav.component.css']
})
export class PrintableNavComponent implements OnInit {
	constructor(protected analyticsDataModel: AnalyticsDataModel) {}
	public printableButtonItems;
	public currentProduct;
	ngOnInit(): void {
		const navWidgets = JSON.parse(JSON.stringify(this.analyticsDataModel.config.navWidgets));
		const overviewNavWidget = _.findWhere(navWidgets, { widgetPath: PATHS.OVERVIEW });
		if (overviewNavWidget) {
			const index = _.indexOf(navWidgets, overviewNavWidget);
			navWidgets.splice(index, 1);
		}
		this.printableButtonItems = navWidgets;
		this.currentProduct = this.analyticsDataModel.getCurrentPath();
	}
}
